import { Link } from "react-router-dom";
import { AppShell } from "@/components/AppShell";
import { Alert } from "@/components/ui/Alert";
import { DOKUMENTE_HUB_SECTIONS } from "@/lib/dokumenteNav";

export function DokumenteSectionHubPage({ section }: { section: string }) {
  const config = DOKUMENTE_HUB_SECTIONS[section];

  if (!config) {
    return (
      <AppShell title="Dokumente">
        <Alert variant="error" title="Bereich nicht gefunden">
          Diese Unterseite ist nicht verfügbar.
        </Alert>
      </AppShell>
    );
  }

  return (
    <AppShell title={config.title} subtitle={config.subtitle}>
      <section className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
        {config.cards.map((card) => (
          <Link
            key={card.key}
            to={card.href}
            className="group flex h-full flex-col gap-3 rounded-ios border border-separator bg-card p-5 shadow-ios transition hover:-translate-y-0.5 hover:border-accent hover:shadow-ios-md focus:outline-none focus-visible:ring-2 focus-visible:ring-accent"
          >
            <div>
              <h2 className="text-base font-semibold text-label">{card.title}</h2>
              <p className="mt-1 text-sm text-label-secondary">{card.description}</p>
            </div>
            <span
              aria-hidden
              className="ml-auto mt-auto text-lg text-label-tertiary transition group-hover:translate-x-0.5 group-hover:text-accent"
            >
              ›
            </span>
          </Link>
        ))}
      </section>
    </AppShell>
  );
}
